import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { updateUserProfileCertificateNudgesCache } from './updateUserProfileCertificateNudgesCache';

const BULK_ACCEPT_USER_CERTIFICATE_NUDGE = gql`
  mutation bulkAcceptUserCertificateNudge(
    $userUri: String!
    $nudgeIds: [String!]!
  ) {
    bulkAcceptUserCertificateNudge(userUri: $userUri, nudgeIds: $nudgeIds) {
      nudges {
        nudgeId
      }
      errors {
        nudge {
          nudgeId
        }
        error
      }
    }
  }
`;

const useBulkAcceptUserCertificateNudge = ({ userUri }) => {
  const [bulkAcceptUserCertificateNudgeMutation] = useMutation(
    BULK_ACCEPT_USER_CERTIFICATE_NUDGE,
    {}
  );

  const bulkAcceptUserCertificateNudge = useCallback(
    async nudgeIds => {
      return bulkAcceptUserCertificateNudgeMutation({
        variables: {
          userUri,
          nudgeIds
        },
        update: (cache, mutationResponse) =>
          updateUserProfileCertificateNudgesCache({
            cache,
            userUri,
            nudgeIds: mutationResponse.data?.bulkAcceptUserCertificateNudge.nudges.map(
              nudge => nudge.nudgeId
            )
          })
      });
    },
    [bulkAcceptUserCertificateNudgeMutation, userUri]
  );

  return { bulkAcceptUserCertificateNudge };
};

export default useBulkAcceptUserCertificateNudge;
